import { GridColDef } from "@mui/x-data-grid-pro";

import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";

/**
 * GenerateHistoricoColumnDefinition 
 */

export const GenerateHistoricoColumnDefinition = (): GridColDef[] => {

  const computeTipoAlteracaoTitle = (status: number) => {
    switch (status) {
      case 2:
        return "Exclusão do produto/serviço";
      case 1:
        return "Edição do produto/serviço";
      case 0:
        return "Adição do produto/serviço";
      default:
        return "?";
    }
  };

  const computeTipoAlteracaoColor = (status: number) => {
    switch (status) {
      case 2:
        return "red";
      case 1:
        return "yellow";
      case 0:
        return "green";
      default:
        return "blue";
    }
  };

  const computeTipoAlteracaoDescription = (status: number) => {
    switch (status) {
      case 2:
        return "Exclusão do produto/serviço";
      case 1:
        return "Edição do produto/serviço";
      case 0:
        return "Adição do produto/serviço";
      default:
        return "?";
    }
  };

  // Tipo

  const computeTipoTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Produto";
      case 0:
        return "Serviço";
      default:
        return "?";
    }
  };

  const computeTipoColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeTipoDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Produto";
      case 0:
        return "Serviço";
      default:
        return "?";
    }
  };

  return [
    {
      field: "tipoAlteracao",
      filterable: false,
      headerName: "Alteração",
      minWidth: 200,
      width: 200,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeTipoAlteracaoTitle(params.value)}
            color={computeTipoAlteracaoColor(params.value)}
            description={computeTipoAlteracaoDescription(params.value)} />
        </div>
      )
    },
    {
      field: "nomeUsuario",
      filterable: false,
      headerName: "Alterado por",
      minWidth: 100,
      width: 100,
      sortable: false,
    },
    {
      field: "dataAlteracao",
      filterable: false,
      headerName: "Data Alteração",
      minWidth: 105,
      width: 105,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <span>{value && dayjs.utc(value).local().format('DD/MM/YYYY')}</span>
        );
      }
    },
    {
      field: "tipo",
      filterable: false,
      headerName: "Tipo",
      minWidth: 80,
      width: 80,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeTipoTitle(params.value === 'P' ? 1 : 0)}
            color={computeTipoColor(params.value === 'P' ? 1 : 0)}
            description={computeTipoDescription(params.value === 'P' ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "numero",
      filterable: false,
      headerName: "Nº",
      minWidth: 70,
      width: 70,
      sortable: false,
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Produto/Serviço",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    {
      field: "unidade",
      filterable: false,
      headerName: "Unidade",
      minWidth: 220,
      width: 220,
      sortable: false,
    },
    {
      field: "quantidade",
      filterable: false,
      headerName: "Quantidade",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div>
            {
              value !== null && value !== undefined
                ? new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
                : ''
            }
          </div>
        );
      }
    },
  ];
}